const RoutePaths = {
    Accounts: '/accounts',
    AccountGroups: '/account-groups',
    Resources: '/resources',
    Events: '/events',
    Operators: '/operators',
    Users: '/users',
    Roles: '/roles',
    Themes: '/themes',
    AccountUsers: '/account-users',
    UserGroups: '/user-groups',
    AccountAdmin: '/account-admin',
    EmailTemplates: '/email-templates',
    EventTracker: '/event-tracker',
    Blueprints: 'blueprints',
    EventHubs: '/event-hubs',
    OeData: '/oe-data',
};

enum Routes {
    EventsList= '/account/:accountId/events/list',
    EventHubList= '/account/:accountId/event-hubs/list',
    EventHubConfiguration= '/account/:accountId/event-hubs/:eventHubId/configuration',
    EventHubWebsiteBuilder= '/account/:accountId/event-hubs/:eventHubId/website-builder',
    EventHubAttendees= '/account/:accountId/event-hubs/:eventHubId/attendees',
    EventBlueprintList= '/account/:accountId/event-blueprints/list',
    MeetingTemplatesList= '/account/:accountId/meeting-templates/list',
    ConnectionTemplatesList= '/account/:accountId/connection-templates/list',
    OrderTemplatesList= '/account/:accountId/order-templates/list',
    AccountUsersList= '/account/:accountId/account-users/list',
    UserGroupsList= '/account/:accountId/user-groups/list',
    AccountAdmin= '/account/:accountId/account-admin',
    AccountAdminSettings= '/account/:accountId/account-admin/settings',
    AccountAdminEventAttributes= '/account/:accountId/account-admin/event-attributes',
    ManageEventAttributes= '/account/:accountId/account-admin/manage-event-attributes/list',
    EmailTemplates= '/account/:accountId/email-templates/list',
    PassportEdit= '/account/:accountId/events/:eventId/website',
    EventManage= '/account/:accountId/events/:eventId',
    Meetings= '/account/:accountId/events/:eventId/meetings/list',
    OrganizationsList= '/account/:accountId/events/:eventId/organizations/list',
    AttendeesList= '/account/:accountId/events/:eventId/attendees/list',
    RoomsList= '/account/:accountId/events/:eventId/rooms/list',
    ConnectionsList= '/account/:accountId/events/:eventId/connections/list',
    Reports= '/account/:accountId/events/:eventId/reports',
    Control= '/account/:accountId/events/:eventId/control',
    Assets= '/account/:accountId/events/:eventId/assets',
    Artifacts= '/account/:accountId/events/:eventId/artifacts',
    AuthCodeFlowCallback= '/auth/callback',
    LogoutScreen= '/auth/logout-callback',
    TrackedZoomUsers= '/resources/zoom/users',
    TelephoneNumberSets= '/resources/zoom/telephone-number-sets',
    AccountsList= '/accounts/list',
    AccountGroupsList= '/account-groups/list',
    ZoomUsersManagement= '/resources/zoom/users/manage',
    ZoomScheduledMeetings= '/resources/zoom/meetings',
    ZoomScheduledMeetingDetails= '/resources/zoom/meetings/:meetingId',
    ZoomScheduledMeetingWebinarDetails= '/resources/zoom/meetings/webinars/:meetingId',
    ZoomScheduleNewMeeting= '/resources/zoom/meetings/new',
    ZoomUpdateMeeting= '/resources/zoom/meetings/:meetingId/update',
    OperatorsList= '/operators/list',
    ThemesList = '/themes/list',
    UsersList = '/users/list',
    RolesList = '/roles/list',
    EventTrackerUpcoming = '/event-tracker/upcoming',
    EventTrackerPast = '/event-tracker/past',
    EventTrackerDelivered = '/event-tracker/delivered',
    OeDataOrganizations = '/oe-data/organizations',
    Default= '/',
    Restricted= '/restricted',
    SsoIdp='/sso',
}

// ideally route params shall be declared inline with route path.
// however i can't identify the way it can be typed. Would be a great improvement
type RouteParams = {
    [Routes.EventsList] : { accountId: string };
    [Routes.EventHubList] : { accountId: string };
    [Routes.EventHubConfiguration] : { accountId: string; eventHubId: string };
    [Routes.EventHubWebsiteBuilder] : { accountId: string; eventHubId: string };
    [Routes.EventHubAttendees] : { accountId: string; eventHubId: string };
    [Routes.EventBlueprintList] : { accountId: string };
    [Routes.MeetingTemplatesList] : { accountId: string };
    [Routes.ConnectionTemplatesList] : { accountId: string };
    [Routes.OrderTemplatesList] : { accountId: string };
    [Routes.AccountUsersList] : { accountId: string };
    [Routes.UserGroupsList] : { accountId: string };
    [Routes.AccountAdmin] : { accountId: string };
    [Routes.AccountAdminSettings] : { accountId: string };
    [Routes.AccountAdminEventAttributes] : { accountId: string };
    [Routes.EmailTemplates] : { accountId: string };
    [Routes.EventManage] : { accountId: string; eventId: string };
    [Routes.PassportEdit] : { accountId: string; eventId: string };
    [Routes.Meetings] : { accountId: string; eventId: string };
    [Routes.AuthCodeFlowCallback] : { code: string };
    [Routes.LogoutScreen]: {};
    [Routes.AccountsList] : { };
    [Routes.AccountGroupsList] : { };
    [Routes.OrganizationsList] : { accountId: string; eventId: string };
    [Routes.AttendeesList] : { accountId: string; eventId: string };
    [Routes.RoomsList] : { accountId: string; eventId: string };
    [Routes.ConnectionsList] : { accountId: string; eventId: string };
    [Routes.Assets]: { accountId: string; eventId: string };
    [Routes.Artifacts]: { accountId: string; eventId: string };
    [Routes.Reports] : { accountId: string; eventId: string };
    [Routes.Control] : { accountId: string; eventId: string };
    [Routes.TrackedZoomUsers] : { page?: string };
    [Routes.TelephoneNumberSets] : { page?: string };
    [Routes.ZoomUsersManagement] : { page?: string };
    [Routes.ZoomScheduledMeetings] : {};
    [Routes.ZoomScheduledMeetingDetails]: { meetingId: string };
    [Routes.ZoomScheduledMeetingWebinarDetails]: { meetingId: string };
    [Routes.ZoomScheduleNewMeeting] : { clonedMeetingId?: string };
    [Routes.ZoomUpdateMeeting] : { meetingId: string };
    [Routes.OperatorsList] : { };
    [Routes.UsersList] : { };
    [Routes.RolesList] : { };
    [Routes.Default] : { };
    [Routes.ThemesList] : { };
    [Routes.EventTrackerUpcoming]: { };
    [Routes.EventTrackerPast]: { };
    [Routes.EventTrackerDelivered]: { };
    [Routes.OeDataOrganizations]: { };
    [Routes.Restricted]: { };
    [Routes.SsoIdp]: { idp?: string };
    [Routes.ManageEventAttributes]: { accountId: string };
};

export { Routes, RouteParams, RoutePaths };
